import React, { useEffect, useReducer, useRef, useState } from "react";
import styles from "./CampForm.css";
import { useDate, useTime } from "./components/Format";

import useSWR from "swr";
import Header from "./components/header";
import ConflictDialog from "./components/ConflictDialog";
import { FormReducer } from "./components/FormReducer";
import FormContent from "./components/FormContent";
import { useParams } from "react-router-dom";
import { reject } from "underscore";
import SuccessDialog from "./components/SuccessDialog";
import ErrorDialog from "./components/ErrorDialog";

const fetcher = (...args) => fetch(...args).then((res) => res.json());

const participantDefaults = () => {
    return {
        firstName: "",
        lastName: "",
        birthDate: "",
        fields: {},
        offers: [],
    };
};

const getSavedState = function () {
    const data = sessionStorage.getItem("state");
    if (!data || data.success) {
        return {
            external: false,
            general: {
                firstName: "",
                lastName: "",

                fields: {},
            },
            participants: [participantDefaults()],
        };
    }

    return JSON.parse(data);
};

const saveState = function (state) {
    sessionStorage.setItem("state", JSON.stringify(state));
};

const clearState = function () {
    sessionStorage.clear();
};

export const CampForm = function ({ }) {
    const { campId } = useParams();

    const { data, error } = useSWR(`/camps/${campId}`, fetcher);
    const { data: capacityData, _ } = useSWR(`/camps/${campId}/capacity`, fetcher, { refreshInterval: 5000 })

    const date = useDate();
    const time = useTime();
    const formRef = useRef();

    const [form, dispatch] = useReducer(FormReducer, getSavedState());

    useEffect(() => {
        saveState(form);
    }, [form]);

    const camp = data?.camp;
    const offers = data?.offers[0] || [];

    if (error) return <div>Formular konnte nichte geladen werden.</div>;
    if (!data) return <div>wird geladen...</div>;

    const submit = (e) => {
        return formSubmit(e, { data, dispatch, form, campId })
    };

    // render data
    return (
        <div className={styles.CampForm}>
            <Dialogs form={form} dispatch={dispatch} offers={offers} />
            <Header />
            <div className={styles.Header}>
                <div className={styles.TitleContainer}>
                    <h1 className={styles.Title}>Anmeldung {camp.name}</h1>
                    <em>
                        Anmeldeschluss: {date(camp.registrationDeadline)},{" "}
                        {time(camp.registrationDeadline)} Uhr
                    </em>
                </div>
                <div className={styles.Description}>
                    <div
                        dangerouslySetInnerHTML={{ __html: camp.description }}
                    ></div>
                </div>
            </div>

            <FormContent
                form={form}
                data={data}
                capacityData={capacityData}
                dispatch={dispatch}
                formRef={formRef}
                formSubmit={submit}
                participantDefaults={participantDefaults}
            />
        </div>
    );
};

const Dialogs = ({ form, offers, dispatch }) => {
    if (form.error) {
        return <ErrorDialog error={form.error} dispatch={dispatch} />;
    }

    if (form.success) {
        return (
            <SuccessDialog orderNo={form.success.orderNo} dispatch={dispatch} />
        );
    }

    if (form.resolve) {
        return (
            <ConflictDialog
                open={true}
                dispatch={dispatch}
                onClose={() => dispatch({ type: "CLEAR_CONFLICT" })}
                form={form}
                offers={offers}
            ></ConflictDialog>
        );
    }
};

const formSubmit = function (e, { data, dispatch, form, campId }) {
    e?.preventDefault();

    const formData = {
        firstName: form.general.firstName,
        lastName: form.general.lastName,
        phonePrivate: form.general.phonePrivate,
        emailPrivate: form.general.emailPrivate,
        phoneBusiness: form.general.phoneBusiness,
        emailBusiness: form.general.emailBusiness,
        useWaitingList: form.general.useWaitingList,
        address: form.general.street + ", " + form.general.location,
        externalEmployee: form.external,
        fieldValues: form.general.fields,
        roleId: form.roleId,
        participants: form.participants.map((p) => ({
            firstName: p.firstName,
            lastName: p.lastName,
            birthDate: p.birthDate,
            offers: p.offers,
            waitingList: p.waitingList || [],
            fieldValues: p.fields,
        })),
    };

    dispatch({
        type: "BEGIN_SEND",
    });

    return fetch(`/camps/${campId}`, {
        method: "POST",
        body: JSON.stringify(formData),
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": data.csrfToken,
        },
    })
        .then((response) => {
            if (response.status == 500) {
                return Promise.reject({
                    messages: ["Unbekannter Serverfehler."],
                    conflicts: null,
                });
            }

            if (response.status == 409 || response.status == 400) {
                return new Promise((resolve, reject) => {
                    response.json().then((data) => reject(data));
                });
            }

            return response.json();
        })
        .then((data) => {
            console.log("Got data", data);
            if (data.orderNo) {
                dispatch({
                    type: "ORDER_SUCCESSFUL",
                    payload: data,
                });
            } else {
                dispatch({
                    type: "SHOW_ERROR",
                    payload: {
                        messages: [
                            "Es ist ein unerwarteteter Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.",
                        ],
                    },
                });
            }
        })
        .catch((data) => {
            console.log("Catched data", data);
            if (data.conflicts) {
                dispatch({
                    type: "RESOLVE_CONFLICT",
                    payload: {
                        messages: data.messages[0],
                        isBookable: true,
                        conflicts: Object.keys(data.conflicts).map(
                            (offerId) => ({
                                offerId,
                                available: data.conflicts[offerId],
                            })
                        ),
                        waitingList: true,
                    },
                });
            } else if (data.messages) {
                dispatch({
                    type: "SHOW_ERROR",
                    payload: {
                        messages: data.messages,
                    },
                });
            } else {
                dispatch({
                    type: "SHOW_ERROR",
                    payload: {
                        messages: [
                            "Es ist ein unerwarteteter Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.",
                        ],
                    },
                });
            }
        })
        .finally(() => dispatch({
            type: "END_SEND",
        }))
};
